<template>
  <div style="margin:10px 20px;" v-loading="loading">
    <div class="split-line"></div>
    <div>
        <div class="view-container">
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">委托单位</div>
                        <div class="view-value">
                            {{project.Pcomname}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">协议编号</div>
                        <div class="view-value">
                            {{project.projectptccode}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">业务员</div>
                        <div class="view-value">
                            {{project.Susername}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">代理单位</div>
                        <div class="view-value">
                            {{project.Acomname}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">项目编号</div>
                        <div class="view-value">
                            {{project.projectcode}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">项目员</div>
                        <div class="view-value">
                            {{project.Cusername}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">项目名称</div>
                        <div class="view-content" style="width:611px;">
                            {{project.projectname}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">项目公告</div>
                        <div class="view-value">
                            {{project.pjnoticetime | newDate}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label" style="line-height:40px;">项目预算</div>
                        <div class="view-val" style="color:#999;width: 250px;">
                            <div>
                                ￥{{project.projectlimitamt | qfwVal}}元
                            </div>
                            <div>
                                (<amount :money="String(project.projectlimitamt)"/>)/{{project.projecthsflg?'含税':'不含税'}}
                            </div>
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">交易方式</div>
                        <div class="view-value">
                            {{project.prsflgdesc}}——{{project.projectquotationmodedesc}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">评审方法</div>
                        <div class="view-value">
                            {{project.projectdoneflgdesc}}——{{project.projectpricecomputebasisdesc}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">报名截止</div>
                        <div class="view-value">
                            {{project.prsbmendtime | longDate}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">有效报名</div>
                        <div class="view-value">
                            {{project.psuYXcount}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">报价开始</div>
                        <div class="view-value">
                            {{project.prsbjbegtime | longDate}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">有效报价</div>
                        <div class="view-value">
                            {{project.psuYXBMcount}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">交易结果</div>
                        <div class="view-value">
                            {{project.iscjgg>0?'成交':'失败'}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-box" v-for="i in this.psuZB" :key="i.psuid">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">成交单位</div>
                        <div class="view-value">
                            {{i.comfullname}}
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label" style="line-height:40px;">成交金额</div>
                        <div class="view-val" style="color:#999;width: 250px;">
                            <div>
                                ￥{{i.psuamt | qfwVal}}元
                            </div>
                            <div>
                               (<amount :money="String(i.psuamt)"/>)
                            </div>
                        </div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">联系方式</div>
                        <div class="view-value">
                            {{i.psucontactname}}{{i.psucontactphone}}
                        </div>
                    </div>
                </div>
            </div>
            <vggrid ref="xGrid" :list="list" tableheight="300" flexname="" :cols="cols"
                    :showfooter="false" :showPage="false" :resizable="true"
                    :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
            >
            </vggrid>
            <div  class="swbox" style="padding:10px;">
                <div class="view-box">
                    <div class="view-row">
                        <div class="view-field">
                            <div class="view-label">实物{{pds.pdslgoodsflag}}</div>
                            <div class="view-value">
                                {{+pds.pdsgoodsflag===1?'有':'无'}}
                            </div>
                        </div>
                        <div class="view-field" v-show="+pds.pdsgoodsflag === 1">
                            <div class="view-label" >实物存放地点</div>
                            <div class="view-value">
                                {{pds.pdsgoodsaddr}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="view-box"  v-show="+pds.pdsgoodsflag === 1">
                    <div class="view-row">
                        <div class="view-field">
                            <div class="view-label">实物描述</div>
                            <div class="">
                              {{pds.pdsgoodsdesc}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div  class="swbox" style="padding:10px;">
                <div class="view-box">
                    <div class="view-row">
                        <div class="view-field">
                            <div class="view-label">提交意见</div>
                            <div class="view-con">
                                {{pds.pdssubmitcontent}}
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div  class="swbox" style="padding:10px;" v-if="pds.pdssubmituserid">
                <div class="view-bt">
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">申请人</div>
                        <div class="view-bt-item-r">{{pds.submitName}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">申请时间</div>
                        <div class="view-bt-item-r">{{pds.pdssubmittime | longDate}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">意见</div>
                        <div class="view-bt-item-r">{{pds.pdssubmitcontent}}</div>
                    </div>
                </div>
            </div>
            <div  class="swbox" style="padding:10px;" v-if="pds.pdscheckuserid">
                <div class="view-bt">
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">审核人</div>
                        <div class="view-bt-item-r">{{pds.reviewName}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">审核时间</div>
                        <div class="view-bt-item-r">{{pds.pdschecktime | longDate}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">意见</div>
                        <div class="view-bt-item-r">{{pds.pdscheckcontent}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import _ from 'lodash'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'
  import utils from '../../assets/js/utils'
  import amount from '../common/amount'
  import vggrid from '../common/vggrid'

  export default {
    name: "xmgdViewFile",
    mixins: [common],
    data () {
      return {
          loading:false,
          pds:{},
          project:{},
          psuZB:[],
          cols:[
            { field: 'pdslcode', fieldtype: 'C', title: '编号',calculExpr:'',addNewRowFlg: false,width:80},
            { field: 'pdslname', fieldtype: 'C', title: '目录名称',calculExpr:'',addNewRowFlg: false},
            { title: '自查', width: 80, showOverflow: true,
                slots: {
                default: 'default',
                default: ({row}) => {
                    return [<span>{+row.pdslselfcheckflag === 2?'有':''}</span>]
                }}
            },
            { title: '实物文件', width: 160, showOverflow: true,
                slots: {
                default: 'default',
                default: ({row}) => {
                    return [
                        <span>{+row.pdslgoodsflag === 1?'有':'无'}</span>
                    ]
                }}
            },
            { title: '自查说明', showOverflow: false,
                slots: {
                default: 'default',
                default: ({row}) => {
                    return [<span>{row.pdslselfcheckcontent} </span>]
                }}
            }
          ],
          itemArr:[
                { title: '审查', width: 80, showOverflow: true,
                    slots: {
                    default: 'default',
                    default: ({row}) => {
                        return [<span>{+row.pdslcheckflag === 2?'有':''}</span>]
                    }}
                },
                { title: '审查说明', showOverflow: false,
                    slots: {
                    default: 'default',
                    default: ({row}) => {
                        if(this.pds){
                            return [<span>{row.pdslcheckcontent} </span>]
                        }
                    }}
                }
          ],
          list:[],
          pList:[]
      }
    },
    async created () {
    },
    async mounted () {
      await this.getpdsInfo()
    },
    components: {amount,vggrid},
    computed: {
    },
    filters: {
      longDate (value) {
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      newDate (value) {
        return dayjs(value).format('YYYY-MM-DD')
      },
      qfwVal (value) {
        if (!!value && +value > 0) {
          return utils.comdify(value)
        } else {
          return value
        }
      }
    },
    methods: {
        async getpdsInfo(){
            this.loading = true
            let res = await request({
                url: '/xmgl/pds/getpdsInfo',
                method: "get",
                params: {
                    projectid: this.$route.query.projectid,
                    cosid:this.$store.getters.loginUser.cosid
                }
            })
            let psuYXList = res.PSUdata.filter(e=>{
                return e.psuas != null 
            })
            this.psuZB = res.PSUdata.filter(e=>{
                return +e.psubidflg === 1 
            })
            this.project = res.PJdata
            if(res.PDSLdata.length>0){
                
                this.pds = res.PDSdata[0]
            }
            if(res.PDSLdata.length>0){
                this.list = res.PDSLdata.filter(e=>{
                    return +e.pdslselfcheckflag === 2 
                })
            }
            if(+this.pds.pdsstaus === 3){
                let index = this.cols.findIndex(e=>{
                    return e.title == '审查'
                })
                if(index == -1){
                    this.itemArr.forEach(e=>{
                        this.cols.push(e)
                    })
                }
            }
            //有效报名projectbmamt  projectbzjamt
            let psuYXBM = res.PSUdata.filter(e=>{
                // if(+e.psustatus === 3){
                    if(res.PJdata.projectbzjamt > 0){
                        return +e.psubzjpayflg === 1 && +e.psustatus === 3
                    }
                    else if(res.PJdata.projectbmamt > 0){
                        return +e.psubmpayflg === 1 && +e.psustatus === 3
                    } else{
                        return +e.psustatus === 3
                    }
                // }
            })
            this.project.psuYXBMcount = psuYXBM.length
            this.project.psuCount = res.PSUdata.length
            this.project.psuYXcount = psuYXList.length
            this.project.iscjgg = res.PJNdata.length
            this.loading = false
        },
        async ViewPdsFile(){
            let {href} = this.$router.resolve({name: 'archives', 
            query: {projectid:this.project.projectid,ptcid:this.project.projectptcid,projectcode:this.project.projectcode,cosid:this.project.projectcosid}})
            window.open(href, '_blank')
        }
    }
  }
</script>

<style lang="scss" scoped>
    .view-content {
      width: 611px;
      color: #999999;
      span {
        color: #999999 !important;
      }
    }
    .swbox{
        margin-top: 10px;
        -moz-box-shadow:0px 0px 1px #333333; -webkit-box-shadow:0px 0px 1px #333333; box-shadow:0px 0px 1px #333333;
    }
    .view-bt{
        display: flex;
        .view-bt-item{
            display: flex;
            .view-bt-item-l{
                width: 110px;
                margin-right: 10px;
                text-align: right;
            }
            .view-bt-item-r{
                color: #999999;
                margin-right: 20px;
                max-width: 600px;
            }
        }
    }
</style>
